import { dataKindsRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { GetDataKindRequest } from "./get-data-kind/GetDataKindRequest";
import { GetDataKindResponse } from "./get-data-kind/GetDataKindResponse";
import { PutDataKindRequest } from "./put-data-kind/PutDataKindRequest";
import { PutDataKindResponse } from "./put-data-kind/PutDataKindResponse";

export const useGetDataKind = () =>
  useRestResourceHook<GetDataKindRequest, GetDataKindResponse>((request) =>
    dataKindsRestResource.getDatakind(request),
  );

export const usePutDataKind = () =>
  useRestResourceHook<PutDataKindRequest, PutDataKindResponse>((request) =>
    dataKindsRestResource.putDatakind(request),
  );
